"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTaxRegistrationNumberPrefilled = exports.isTaxRegistrationNumberRequired = exports.isSalesTaxCountry = void 0;
const country_1 = require("../enums/country");
const SALES_TAX_COUNTRIES = [country_1.OrganizationCountry.Canada, country_1.OrganizationCountry.UnitedStates];
const isSalesTaxCountry = (country) => {
    if (!country) {
        return false;
    }
    return SALES_TAX_COUNTRIES.includes(country);
};
exports.isSalesTaxCountry = isSalesTaxCountry;
const isTaxRegistrationNumberRequired = (country) => country === country_1.OrganizationCountry.Canada;
exports.isTaxRegistrationNumberRequired = isTaxRegistrationNumberRequired;
const isTaxRegistrationNumberPrefilled = (country) => country === country_1.OrganizationCountry.UnitedStates;
exports.isTaxRegistrationNumberPrefilled = isTaxRegistrationNumberPrefilled;
